<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="modal fade" id="costumModalpeta" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);">
            <div class="modal-dialog modal-fullscreen" style="width: 98vw;">
                <div class="modal-content" style="height: auto;min-width: 95vw;">
                    <div class="modal-header">
                        <h4 class="modal-title">Upload Dokumen</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify" style="height: auto;min-width: 95vw;">
                        <p>
                        <div class="row">
                            <div class="col-sm-12 float-left">
                                <label>Paket Pekerjaan</label>
                                <v-select :options="paket_pekerjaan" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedpaket_pekerjaan"
                                    @update:modelValue="onpaket_pekerjaanChange"
                                    style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                            </div>
                            <div class="col-sm-12">
                                <label>Nama Dokumen</label>
                                <input class="form-control form-control-sm" type="text"
                                    placeholder="Tuliskan Nama Dokumen.." v-model="nama_file_docevent" id="nama_file_docevent" name="nama_file_docevent">
                                <br>
                            </div>
                            <div class="col-sm-12">
                                <label>File<small class="text-info"> (*pdf)</small>
                                </label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="far fa-file-pdf"></i></span>
                                    </div>
                                    <input type="file" class="form-control form-control-sm"
                                        id="fileToUploadfile_docevent" name="fileToUploadfile_docevent"
                                        placeholder="fileToUpload" style="font-size: smaller;" accept="application/pdf">
                                    <input type="hidden" class="form-control form-control-sm" id="file_docevent"
                                        name="file_docevent" placeholder="File Beranda">
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <label>Opsi</label>
                                <div class="row">
                                    <div class="col-sm-9">
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                id="persennyafile_docevent">
                                                <span id="tulisanpersenfile_docevent">0%</span>
                                            </div>
                                        </div>
                                        <br>
                                        <span class="text-success" id="suksesnyafile_docevent"></span>
                                    </div>
                                    <div class="col-sm-3 text-center">
                                        <button type="button" class="btn btn-warning btn-sm lebar text-white"
                                            @click="uploadfile('file_docevent', 'application/pdf')">Upload
                                            File</button>
                                        <button type="button" class="btn btn-danger btn-sm lebar"
                                            @click="clearfilepeta('file_docevent')">Hapus
                                            File</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success3 btn-sm lebar2 text-white" @click="update()"><i
                                class="fas fa-paper-plane"></i>
                            Kirim</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Tutup</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div class="modal fade" id="costumModalverifikasi" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);">
            <div class="modal-dialog modal-fullscreen" style="width: 45vh;">
                <div class="modal-content" style="height: 50vh;min-width: 35vw;">
                    <div class="modal-header">
                        <h4 class="modal-title">Verifikasi Dokumen</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <p>
                        <div class="row">
                            <div class="col-sm-12 float-left">
                                <label>Verifikasi Dokumen</label>
                                <v-select :options="status_dokumen" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedstatus_dokumen" @update:modelValue="onstatus_dokumenChange"
                                    style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                            </div>
                            <div class="col-sm-6 float-left">
                                <input type="hidden" class="form-control form-control-sm"
                                        id="id_event" name="id_event" v-model="id_event"
                                        placeholder="" style="font-size: smaller;">
                                <label>Jumlah Peserta Laki-laki</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-user-check"></i></span>
                                    </div>
                                    <input type="number" class="form-control form-control-sm"
                                        id="jumlah_laki" name="jumlah_laki" v-model="jumlah_laki"
                                        placeholder="Jumlah Peserta Laki-laki" style="font-size: smaller;">
                                </div>
                            </div>
                            <div class="col-sm-6 float-left">
                                <label>Jumlah Peserta Perempuan</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-user-check"></i></span>
                                    </div>
                                    <input type="number" class="form-control form-control-sm"
                                        id="jumlah_perempuan" name="jumlah_perempuan" v-model="jumlah_perempuan"
                                        placeholder="Jumlah Peserta Perempuan" style="font-size: smaller;">
                                </div>
                            </div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success3 btn-sm lebar2 text-white"
                            @click="verifikasidokumen()"><i class="fas fa-paper-plane"></i>
                            Simpan</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Tutup</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div class="modal fade" id="costumModalpetagambar" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);">
            <div class="modal-dialog modal-fullscreen" style="width: 98vw;">
                <div class="modal-content" style="height: auto;min-width: 95vw;">
                    <div class="modal-header">
                        <h4 class="modal-title">Upload Dokumentasi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify" style="height: auto;min-width: 95vw;">
                        <p>
                        <div class="row">
                            <div class="col-sm-12">
                                <label>File<small class="text-info"> (*jpg)</small>
                                </label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="far fa-file-pdf"></i></span>
                                    </div>
                                    <input type="file" class="form-control form-control-sm" id="fileToUploadfile_name"
                                        name="fileToUploadfile_name" placeholder="fileToUpload"
                                        style="font-size: smaller;" accept="image/*">
                                    <input type="hidden" class="form-control form-control-sm" id="file_name"
                                        name="file_name" placeholder="File Beranda">
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <label>Opsi</label>
                                <div class="row">
                                    <div class="col-sm-9">
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                id="persennyafile_name">
                                                <span id="tulisanpersenfile_name">0%</span>
                                            </div>
                                        </div>
                                        <br>
                                        <span class="text-success" id="suksesnyafile_name"></span>
                                    </div>
                                    <div class="col-sm-3 text-center">
                                        <button type="button" class="btn btn-warning btn-sm lebar text-white"
                                            @click="uploadfile('file_name', 'image/*')">Upload
                                            File</button>
                                        <button type="button" class="btn btn-danger btn-sm lebar"
                                            @click="clearfilepeta('file_name')">Hapus
                                            File</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success3 btn-sm lebar2 text-white" @click="update()"><i
                                class="fas fa-paper-plane"></i>
                            Kirim</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Tutup</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Inbox">Data Inbox Agenda</a></li>
                                <li class="breadcrumb-item active">Pengaturan Data Inbox Agenda</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Agenda</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="post">
                                        <div class="user-block">
                                            <img class="img-circle img-bordered-sm" :src="folder + gambar"
                                                alt="user image">
                                            <span class="username">
                                                <a href="#">{{ namauser }}</a>
                                            </span>
                                            <span class="description">{{ G_formatDate(mulai) }}</span>
                                        </div>
                                        <!-- /.user-block -->
                                        <p>
                                            <span class="text-danger">{{ agenda }}</span>, {{ topik }}
                                        </p>
                                        <p>
                                            <span class="float-right">
                                                <a href="#" class="link-black text-sm">
                                                    <i class="far fa-comments mr-1"></i> Komentar ({{ jml_komen }})
                                                </a>
                                            </span>
                                            <span v-for="(datalist, urutlist) in detail" :key="urutlist">
                                                <p style="font-size: smaller;">
                                                <div class="row">
                                                    <hr>
                                                    </hr>
                                                    <div class="col-sm-12">
                                                        <div class="user-block">
                                                            <span class="float-right"
                                                                v-if="datalist.id_user == id_user">
                                                                <a href="javascript:void(0)" class="link-black text-sm"
                                                                    @click="hapus(datalist.id)">
                                                                    <i class="fas fa-window-close mr-1"></i>
                                                                </a>
                                                            </span>
                                                            <img class="img-circle img-bordered-sm"
                                                                :src="folder + datalist.gambar" alt="user image">
                                                            <span class="username"
                                                                style="font-size: smaller !important;">
                                                                <a href="#">{{ datalist.namauser }}</a>
                                                            </span>
                                                            <span class="description"
                                                                style="font-size: smaller !important;">
                                                                {{ G_formatDate(datalist.createddate) }}
                                                            </span>
                                                            <span class="description">{{ datalist.komentar }}</span>
                                                            <span class="description" v-if="datalist.paket != '0'"
                                                                style="font-size: smaller;color: blue;">
                                                                Paket Pekerjaan: #{{ datalist.Nama_Kegiatan }}
                                                            </span>
                                                            <span class="description"
                                                                v-if="datalist.file_docevent != ''"
                                                                style="font-size: smaller;">
                                                                <a href="javascript:void(0)"
                                                                    @click="verifikasi(datalist.id, datalist.status_dokumen)"
                                                                    v-if="datalist.status_dokumen == '0'">
                                                                    <i class="far fa-check-circle"
                                                                        style="color: red;"></i> <span
                                                                        style="color: red;">(Proses Verifikasi)</span>
                                                                </a>
                                                                <a href="javascript:void(0)"
                                                                    v-else-if="datalist.status_dokumen == '2'">
                                                                    <i class="far fa-check-circle"
                                                                        style="color: yellow;"></i> <span
                                                                        style="color: yellow;">(Revisi)</span>
                                                                </a>
                                                                <a href="javascript:void(0)"
                                                                    v-else-if="datalist.status_dokumen == '2'">
                                                                    <i class="far fa-check-circle"
                                                                        style="color: brown;"></i> <span
                                                                        style="color: brown;">(Ditolak)</span>
                                                                </a>
                                                                <a href="javascript:void(0)" v-else>
                                                                    <i class="far fa-check-circle"
                                                                        style="color: green;"></i> <span
                                                                        style="color: green;">(Verifikasi)</span>
                                                                </a>
                                                                <a :href="pdfnya + datalist.file_docevent"
                                                                    target="_blank">
                                                                    Lihat Lampiran File
                                                                    {{ datalist.nama_file_docevent }}
                                                                </a>
                                                            </span>
                                                            <span class="description" v-if="datalist.file_name != ''"
                                                                style="font-size: smaller;">
                                                                <img class="w-50 h-50"
                                                                    v-if="datalist.file_name != ''"
                                                                    :src="imgnya + datalist.file_name" alt="user image">
                                                            </span>

                                                        </div>
                                                    </div>
                                                    <hr>
                                                    </hr>
                                                </div>
                                        </p>
                                        </span>
                                        </p>
                                        <p>
                                            <a href="javascript:void(0)" class="link-black text-sm mr-2"
                                                @click="uploaddokumen()"><i class="far fa-file-pdf mr-1"></i> File</a>
                                            <a href="javascript:void(0)" class="link-black text-sm"
                                                @click="uploadfoto()"><i class="fas fa-photo-video mr-1"></i> Foto</a>
                                        </p>
                                        <input class="form-control form-control-sm" type="text"
                                            placeholder="Tuliskan komentar.." v-model="komentar" id="komentar"
                                            name="komentar">
                                        <br>
                                        <button type="button" class="btn btn-sm btn-success3 float-left text-white"
                                            v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                            data-placement="left" title="Kirim data.."><i
                                                class="fas fa-paper-plane"></i>
                                            Kirim
                                        </button>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <div class="col-sm-12">
                                        &nbsp;
                                    </div>
                                    <div class="col-sm-12">
                                        &nbsp;
                                    </div>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah')" data-toggle="tooltip"
                                        data-placement="left" title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Tutup proses.."><i class="fas fa-window-close"></i> Tutup</button>
                                </div>
                                <div class="col-sm-12">
                                    &nbsp;
                                </div>
                                <div class="col-sm-12">
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            id_user: JSON.parse(localStorage.getItem("isistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            gambar: '',
            agenda: '',
            topik: '',
            namauser: '',
            mulai: '',
            selesai: '',
            komentar: '',
            leveluser: [],
            dataleveluser: [],
            defaultSelectedleveluser: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedleveluser: '',
            iduser: [],
            dataiduser: [],
            defaultSelectediduser: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectediduser: '',
            validasi: false,
            folder: process.env.VUE_APP_URL_API + 'parastapainnovationgetuser-Gambar?f=',
            pdfnya: process.env.VUE_APP_URL_API + 'parastapainnovation_comment-PDF?f=',
            imgnya: process.env.VUE_APP_URL_API + 'parastapainnovation_comment-Dokumentasi?f=',
            jml_komen: 0,
            detail: [],
            paket_pekerjaan: [],
            datapaket_pekerjaan: [],
            defaultSelectedpaket_pekerjaan: {
                code: 0,
                label: 'Tidak Ada',
                tag: '',
            },
            selectedpaket_pekerjaan: '',
            idnyaevent: '',
            nama_file_docevent: '',
            status_dokumen: [],
            datastatus_dokumen: [],
            defaultSelectedstatus_dokumen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '0',
            },
            selectedstatus_dokumen: '0',
            id_verifikasi: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            jumlah_laki: 0,
            jumlah_perempuan: 0,
            id_event: 0,
        }
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        async verifikasidokumen() {
            var secretencData = this.secretencData;
            var fd = new FormData();
            fd.append("kode", this.id_verifikasi);
            fd.append("id_event", this.id_event);
            fd.append("jumlah_perempuan", this.jumlah_perempuan);
            fd.append("jumlah_laki", this.jumlah_laki);
            fd.append("status_dokumen", this.selectedstatus_dokumen);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_comment-Verifikasi", fd).then(
                Response => {
                    var kode = secretencData;
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                        swal.fire('Informasi', 'Dokumen telah diverifikasi..', 'success').then(function () {
                            window.location.replace("/ProsesInbox/" + bytes);
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        async verifikasi(kode, status) {
            //alert(kode);
            //alert(status);
            if (this.roleuser == 'user') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tidak berwenang untuk melakukan verifikasi',
                });
                return false;
            }
            this.id_verifikasi = kode;
            this.status_dokumen.forEach((item) => {
                if (item.id == status) {
                    this.selectedstatus_dokumen = item.id;
                    this.defaultSelectedstatus_dokumen = {
                        code: item.code,
                        label: item.label,
                        tag: item.tag,
                    };
                }
            });
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovation_pesertaevent-Peserta?random=" + random + "&project_id=" + this.project_id + "&kode=" + kode).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.jumlah_laki= Response.data.content.data[0].jumlah_laki;
                        //alert(this.jumlah_laki);
                        this.jumlah_perempuan= Response.data.content.data[0].jumlah_perempuan;
                        //alert(this.jumlah_perempuan);
                        this.id_event= Response.data.content.data[0].id_event;
                        $('#costumModalverifikasi').modal('show');
                        this.halamanloading = false;
                    }
                    else {
                        $('#costumModalverifikasi').modal('show');
                        this.halamanloading = false;
                    }
                    
                }
            ).catch(error => {
                console.log(error);
                $('#costumModalverifikasi').modal('show');
                this.halamanloading = false;
            })
            
        },
        onpaket_pekerjaanChange(a) {
            try {
                this.selectedpaket_pekerjaan = this.paket_pekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onstatus_dokumenChange(a) {
            try {
                this.selectedstatus_dokumen = this.status_dokumen[a].tag;
            }
            catch (err) {
                return;
            }
        },
        async AmbilDataReff() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_kegiatan-GetProyekKegiatan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datapaket_pekerjaan = [];
                        this.paket_pekerjaan = [];
                        this.datapaket_pekerjaan = Response.data.content.data;
                        this.datapaket_pekerjaan.forEach((item) => {
                            this.paket_pekerjaan.push({
                                label: item.nama,
                                code: this.datapaket_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.paket_pekerjaan.unshift({
                            label: 'Tidak Ada',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            })

            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_verifikasi-GetData?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datastatus_dokumen = [];
                        this.status_dokumen = [];
                        this.datastatus_dokumen = Response.data.content.data;
                        this.datastatus_dokumen.forEach((item) => {
                            this.status_dokumen.push({
                                label: item.nama,
                                code: this.datastatus_dokumen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.status_dokumen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '0',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            })
        },
        uploaddokumen() {
            $('#costumModalpeta').modal('show');
        },
        uploadfoto() {
            $('#costumModalpetagambar').modal('show');
        },
        async hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Komentar?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_comment-Hapus", data).then(
                        Response => {
                            var kode = this.secretencData;
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/ProsesInbox/" + bytes);
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        onleveluserChange(a) {
            try {
                this.selectedleveluser = this.leveluser[a].tag;
            }
            catch (err) {
                return;
            }
        },
        oniduserChange(a) {
            try {
                this.selectediduser = this.iduser[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Inbox");
        },
        async AmbilData() {
            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIData.get("parastapainnovation_tim-GetReff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataleveluser = [];
                        this.leveluser = [];
                        this.dataleveluser = Response.data.content.data;
                        this.dataleveluser.forEach((item) => {
                            this.leveluser.push({
                                label: item.nama,
                                code: this.dataleveluser.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.leveluser.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            var random = Math.random();
            await mainAPIData.get("parastapainnovation-GetAllUser?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.response;
                    if (this.datapesan == 'success') {
                        this.dataiduser = [];
                        this.iduser = [];
                        this.dataiduser = Response.data.content.data;
                        this.dataiduser.forEach((item) => {
                            this.iduser.push({
                                label: item.nama,
                                code: this.dataiduser.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.iduser.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.detail = [];
            this.idnyaevent = '';
            var random = Math.random();
            if (this.secretencData.includes("_")) {
                var pembaca = this.id_user;
                var temp = this.secretencData.split("_");
                var id_user = temp[1];
                var secretencData = temp[0];
                //var pembaca = temp[1];
            }
            else {
                var id_user = this.id_user;
                var secretencData = this.secretencData;
                var pembaca = this.id_user;
            }
            //alert(pembaca);
            await mainAPIDataSingel.get("parastapainnovation_inbox-GetByID?kode=" + secretencData + "&random=" + random + "&project_id=" + this.project_id + "&id_user=" + id_user + "&pembaca=" + pembaca).then(
                Response => {
                    this.gambar = Response.data.content.data[0].gambar;
                    this.agenda = Response.data.content.data[0].agenda;
                    this.topik = Response.data.content.data[0].topik;
                    this.namauser = Response.data.content.data[0].namauser;
                    this.mulai = Response.data.content.data[0].mulai;
                    this.selesai = Response.data.content.data[0].selesai;
                    this.urutdata = Response.data.content.data[0].urut;
                    this.selectedleveluser = Response.data.content.data[0].posisi;
                    this.selectediduser = Response.data.content.data[0].id_user;
                    this.jml_komen = Response.data.content.data[0].jml_komen;
                    this.detail = Response.data.content.data[0].detail;
                    this.idnyaevent = Response.data.content.data[0].idnyaevent;
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            this.halamanloading = true;
            var mainAPIData = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIData.get("parastapainnovation_tim-GetReff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataleveluser = [];
                        this.leveluser = [];
                        this.dataleveluser = Response.data.content.data;
                        this.dataleveluser.forEach((item) => {
                            this.leveluser.push({
                                label: item.nama,
                                code: this.dataleveluser.indexOf(item) + 1,
                                tag: item.id,
                            });
                            if (this.selectedleveluser == item.id) {
                                this.defaultSelectedleveluser = {
                                    label: item.nama,
                                    code: this.dataleveluser.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                        });
                        this.leveluser.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

            var random = Math.random();
            await mainAPIData.get("parastapainnovation-GetAllUser?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.response;
                    if (this.datapesan == 'success') {
                        this.dataiduser = [];
                        this.iduser = [];
                        this.dataiduser = Response.data.content.data;
                        this.dataiduser.forEach((item) => {
                            this.iduser.push({
                                label: item.nama,
                                code: this.dataiduser.indexOf(item) + 1,
                                tag: item.id,
                            });
                            if (this.selectediduser == item.id) {
                                this.defaultSelectediduser = {
                                    label: item.nama,
                                    code: this.dataiduser.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                        });
                        this.iduser.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        validasidata() {
            if (this.komentar == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Komentar',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            
            if (document.getElementById('file_docevent').value != '') {
                if (this.nama_file_docevent == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Nama Dokumen',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var secretencData = this.secretencData;

            //alert(this.secretencData);
            var fd = new FormData();
            fd.append("komentar", this.komentar);
            fd.append("file_docevent", document.getElementById('file_docevent').value);
            fd.append("file_name", document.getElementById('file_name').value);
            fd.append("id_user", this.id_user);
            fd.append("paket", this.selectedpaket_pekerjaan);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id_event", this.idnyaevent);
            fd.append("nama_file_docevent", this.nama_file_docevent);
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_comment-Add", fd).then(
                Response => {
                    var kode = secretencData;
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                        swal.fire('Informasi', 'Komentar telah ditambahkan..', 'success').then(function () {
                            window.location.replace("/ProsesInbox/" + bytes);
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.AmbilDataReff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
        else {
            this.AmbilData();
        }
        //alert(this.secretencData);
    }
}
</script>
<style></style>